export const PricingCardcontent = [
  {
    title: "Basic",
    price: "$0",
    time: "Month",
    duration: "Suitable for personal websites",
    buy_now_link: "",
    free_trail_link: "/register?plan=basic",
    services: [
      "For 2 Agents",
      "Live Chat",
      "Appointment Scheduling",
      "Customizations",
      "Free Forever"
    ]
  },
  {
    title: "Essential",
    price: "$25",
    time: "Month",
    duration: "Suitable for early stage Startups ",
    buy_now_link: "29879",
    free_trail_link: "/register?plan=essential",
    services: [
      "Up to 4 Agents",
      "Live Chat",
      "Email Ticketing",
      "Appointment Scheduling",
      "Real Time Analytics",
      "Lead Management",
      "Customizations",
      "14 days Trial"
    ]
  },
  {
    title: "Pro",
    price: "$47",
    time: "Month",
    duration: "Suitable for scaling Businesses who want more for less.",
    buy_now_link: "29880",
    free_trail_link: "/register?plan=pro",
    services: [
      "Up to 10  Agents",

      "Live chat",

      "Email Ticketing",

      "Appointment scheduling",

      "Knowledgebase center",

      "Real Time Analytics",

      "Lead management",

      "Customizations",

      "14 days trial"
    ]
  }

  // {
  //   title: "All Paid Plans Comes with ",
  //   price: "",
  //   duration: "",
  //   buy_now_link: "",
  //   free_trail_link: "",
  //   type: "Not Plan",
  //   services: [
  //     "14 days Free Trial",

  //     "Typing Preview",

  //     "Unlimited Chat History",

  //     "Chat Widget Customization",

  //     "Booking Link Customization",

  //     "Canned Response",

  //     "Private Note for Teams",
  //   ],
  // },
];
